module.exports = __webpack_public_path__ + "img/sia_909l_list.2e6c0a73.jpg";